<mat-form-field appearance="outline" class="language-select-field" subscriptSizing="dynamic">
  <mat-select aria-label="Language" [value]="activeLang" (selectionChange)="setActiveLang($event.value)">
    @for (lang of availableLangs; track lang) {
      <mat-option [value]="lang">{{ lang | uppercase }}</mat-option>
    }
  </mat-select>
</mat-form-field>
